<template>
  <router-view />
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "App",

  created() {
    this.$store.dispatch("stades/fetchStades");
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<!-- style tag is mandatory in app.vue to load scss with sass loader -->
<style lang="scss"></style>
